'use strict';

const fast = "200ms";
const moderate = "300ms";
const moderatelySlow = "400ms";
const slow = "500ms";
const ultraSlow = "1400ms";

exports.fast = fast;
exports.moderate = moderate;
exports.moderatelySlow = moderatelySlow;
exports.slow = slow;
exports.ultraSlow = ultraSlow;
//# sourceMappingURL=duration.cjs.map
